var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_10824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74993 15.5C8.6147 15.5 8.48311 15.4561 8.37493 15.375L5.87493 13.5C5.7973 13.4418 5.7343 13.3663 5.69091 13.2795C5.64752 13.1927 5.62493 13.097 5.62493 13V9.4875L1.23993 4.55438C0.928502 4.20305 0.725164 3.76926 0.654352 3.30515C0.58354 2.84103 0.648267 2.36634 0.840754 1.93813C1.03324 1.50992 1.3453 1.14641 1.73941 0.891291C2.13353 0.63617 2.59294 0.500297 3.06243 0.5H11.9374C12.4069 0.500551 12.8662 0.63665 13.2601 0.891942C13.6541 1.14723 13.9659 1.51086 14.1582 1.93912C14.3505 2.36737 14.415 2.84205 14.344 3.30609C14.2731 3.77014 14.0696 4.20381 13.7581 4.555L9.37493 9.4875V14.875C9.37493 15.0408 9.30908 15.1997 9.19187 15.3169C9.07466 15.4342 8.91569 15.5 8.74993 15.5Z",
    fill: "#2487FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_10824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fef540249bff62897ecf9d2dcc4a19fc.svg";
export { ForwardRef as ReactComponent };